module.exports = __webpack_public_path__ + "static/media/Sina.0b60fdd3.svg";